module.exports = __webpack_public_path__ + "media/images/supporters_lp/fork23-23c60ce6ffaab4bbabc01825a6890a00.png";